import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import user from './user';
import merchant from './merchant';

const reducer = combineReducers({
  // here we will be adding reducers
  user,
  merchant
});

const store = configureStore({
  reducer
});

export default store;
